import { makeStyles } from '@material-ui/styles'

export const InfoPageStyles = makeStyles((theme) => ({
  appBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 25,
    background: theme.palette.background.paper,
    color: 'rgba(0,0,0,0.54)',
  },
  appBarContainer: {
    flex: 1,
    width: '100%',
    backgroundColor: theme.palette.background.default,
    overflow: 'auto',
    overscrollBehavior: 'contain',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    justifyContent: 'center',
    // paddingTop: 55,
  },
  pageTitle: {
    display: '-webkit-box',
    boxOrient: 'vertical',
    lineClamp: 1,
    wordBreak: 'keep-all',
    overflow: 'hidden',
    color: theme.palette.base.red,
    fontSize: 22,
    fontWeight: '400',
  },
  container: {
    background: theme.palette.components.newsBackground,
    overflowX: 'hidden',
    width: '100%',
    paddingBottom: '24px',
    paddingTop: '110px',
    paddingLeft: '55px',
    paddingRight: '20px',
    height: '100vh',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
    },
  },
  headerContainer: {
    background: theme.palette.components.newsBackground,
    borderRadius: '15px',
    height: 'auto',
    marginTop: '16px',
    marginLeft: '16px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '55px',
    },
  },
  appContainer: {
    background: theme.palette.components.newsBackground,
    borderRadius: '8px',
    marginBottom: '30px',

    [theme.breakpoints.down('md')]: {
      marginLeft: '55px',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: '3%',
    },
  },
  carouselContainer: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '55px',
    },
  },
  img: {
    height: '200px',
    width: 'auto',
    maxWidth: '50%',
    marginTop: 'auto',
    marginBottom: 'auto',
    paddingTop: '10px',
    paddingBottom: '10px',
    marginLeft: '10px',
    borderRadius: '15px 15px 15px 15px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
      maxWidth: '100%',
    },
  },
  categoryTitleContainer: {
    marginLeft: '16px',
    paddingRight: '16px',
    marginTop: '8px',
  },
  categoryTitle: {
    textAlign: 'start',
    color: theme.palette.primary.headerText,
    fontSize: '32px',
  },
  categoryDescription: {
    textAlign: 'start',
    color: theme.palette.primary.headerText,
    fontSize: '20px',
    marginRight: '20px',
    paddingBottom: '10px',
  },
  iconButton: {
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: theme.palette.components.icon,
    borderRadius: '50%',
    boxSizing: 'border-box',
    marginRight: '8px',
  },
}))

export default InfoPageStyles
